import Logo from '../../../_metronic/assets/logo.png'
import {Fragment, useEffect, useRef, useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useMerchantData} from '../hook'
import ContactUs from '../components/ContactUs'
import {useIntl} from 'react-intl'
import Swal from 'sweetalert2'
import FreeTrialImg from './assets/images/14-daysfree.png'
import FreeTrialImg2 from './assets/images/14-daysfree-2.png'

import {Modal, Spinner} from 'react-bootstrap'
import './style.css'
import {useGetTransactionDetail, useMakePayment} from '../context/useMutation'
import {Error} from 'src/feature/bite/helpers/notification'

import PaymentSuccess from './success'

export default function BecomeAMerchantPricing() {
  const paymentProviderUrl = process.env.REACT_APP_PAYMENT_PROVIDER
  const iframeRef = useRef<HTMLIFrameElement | null>(null)
  const [selectedPackage, setSelectedPackage] = useState<any>(null)
  const [modal, setModal] = useState(false)
  const intl = useIntl()
  const navigate = useNavigate()
  const {merchantData} = useMerchantData()
  const packageRef = useRef(null) as any
  const packageRef2 = useRef(null) as any
  const packageEnterpriceRef = useRef(null) as any
  const packageEnterpriceRef2 = useRef(null) as any
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [paymentDialog, setPaymentDialog] = useState(false)
  const [paymentDialogUrl, setPaymentDialogUrl] = useState('')
  const {mutateAsync: sendPayment} = useMakePayment()
  const [expandMore, setExpandMore] = useState({
    status: false,
    expandedPackageId: '',
  })

  const {mutateAsync: getTransactionDetail, isLoading: isTransactionDetailLoading} =
    useGetTransactionDetail()

  const [paymentPeriod, setPaymentPeriod] = useState('annual')
  const [searchParams, setSearchParams] = useSearchParams()
  const merchantIDQuery = searchParams.get('merchantID')

  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [paymentError, setPaymentError] = useState(false)

  const [transactionDetail, setTransactionDetail] = useState<any>(null)

  if (!merchantIDQuery) {
    navigate('/sign-in')
  }

  const essentialPrice = {
    monthly: process.env.REACT_APP_STARTER_PRICE_MON,
    annual: process.env.REACT_APP_STARTER_PRICE_YEAR,
  }

  const packages = [
    {
      // packageName: 'Welcome Offer',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.WELCOME_OFFER'}),
      packageID: 'd22c0ab4-f86f-4edf-b673-ba45e9b2ffe8',
      price: '',
      discountedPrice: essentialPrice.monthly,
      annualPrice: essentialPrice.annual,
      trxFee: '10%',
      settlementFee: '5',
      monthlyOrderLimit: '25',
      featuredDays: '0',
      costPerUser: '-',
      monthlyTrxFeePerLylTrx: 'AED 0.10',
      pointCouponRedemptionFee: '2.50%',
      paymentProcessingCommission: '9.99%',
      discountsPromoEngine: '0',
      inAppNotifications: 'No',
      inventoryManagement: 'Unlimited',
      reporting: 'Unlimited',
      perfectFor: 'For Freelancers',
      loyaltyMembersServed: '0',
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '0',
      costPerEmail: '-',
      // customerSupport: 'Live Chat',
      customerSupport: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Mail'}),
      portalUser: '1',
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 250,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.50',
        couponUsage: '2.50',
      },
      infos: [
        'Vasco App Listing',
        'Unlimited Transactions',
        'Payment Collection',
        'Form Management',
        'Vasco Support (Email)',
      ],
    },
    {
      // packageName: 'Growth',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.GROWTH'}),
      packageID: '09bff025-1f77-4220-b684-8b4bf193c4af',
      price: '99.99',
      discountedPrice: '249.00',
      annualPrice: '2,490.00',
      trxFee: '8%',
      settlementFee: '5',
      featuredDays: '0',
      monthlyOrderLimit: '500',
      costPerUser: '50',
      discountsPromoEngine: '0',
      monthlyTrxFeePerLylTrx: 'AED 0.10',
      pointCouponRedemptionFee: '2.50%',
      paymentProcessingCommission: '7.99%',
      inAppNotifications: 'Unlimited',
      inventoryManagement: 'Unlimited',
      reporting: 'Unlimited',
      loyaltyMembersServed: '0',
      perfectFor: 'For Single Location Service Providers',
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '0',
      costPerEmail: '0.15',
      portalUser: '1',
      // customerSupport: 'Live Chat',
      customerSupport: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Mail'}),
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 250,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.00',
        couponUsage: '2.00',
      },
      infoTitle: 'Everything in Essential, plus:',
      infos: ['Vasco Support (WhatsApp)', 'Marketplace Listing'],
    },
    {
      // packageName: 'Pro',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PRO'}),
      perfectFor: 'For Academies/Multi-venue Service Providers',
      packageID: 'e01e9227-2182-4112-87d6-78b8e2559f65',
      price: '499.00',
      discountedPrice: '499.00',
      featuredDays: '2',
      trxFee: '6.5%',
      settlementFee: '5',
      discountsPromoEngine: '0',
      costPerUser: '40',
      annualPrice: '4,990.00',
      monthlyOrderLimit: '1,000',
      monthlyTrxFeePerLylTrx: 'AED 0.10',
      pointCouponRedemptionFee: '2.50%',
      addVenue: '99',
      inAppNotifications: 'Unlimited',
      inventoryManagement: 'Unlimited',
      reporting: 'Unlimited',
      paymentProcessingCommission: '6.99%',
      loyaltyMembersServed: '0',
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '500',
      costPerEmail: '0.10',
      portalUser: '2',
      // customerSupport: 'Live Agent & Live Chat',
      customerSupport: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Mail'}),
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 500,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.00',
        couponUsage: '2.00',
      },
      infoTitle: 'Everything in Basic, plus:',
      infos: ['Create & Schedule Email Campaigns', 'Dedicated Account Manager'],
    },
    {
      // packageName: 'Pro',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PRO_2'}),
      perfectFor: 'For Country-wide or Regional Coverage',
      packageID: '06ca67a5-7e3d-499a-935b-b93ef6c7de36',
      price: '199.99',
      discountsPromoEngine: '15',
      featuredDays: '5',
      trxFee: '5%',
      addVenue: '49',
      settlementFee: '5',
      discountedPrice: '749.00',
      costPerUser: '25',
      annualPrice: '7,490.00',
      monthlyOrderLimit: 'Unlimited',
      monthlyTrxFeePerLylTrx: 'AED 0.10',
      pointCouponRedemptionFee: '2.50%',
      inAppNotifications: 'Unlimited',
      reporting: 'Unlimited',
      inventoryManagement: 'Unlimited',
      paymentProcessingCommission: '4.99%',
      loyaltyMembersServed: '1,000',
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '2,500',
      costPerEmail: '0.05',
      portalUser: '3',
      // customerSupport: 'Live Agent & Live Chat',
      customerSupport: '+' + intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Agent'}),
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 500,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.00',
        couponUsage: '2.00',
      },
      infoTitle: 'Everything in Growth, plus:',
      infos: ['VIP Member Management', 'Vasco Loyalty & Rewards', 'Dedicated Account Manager'],
    },
  ]

  const faqs = [
    {
      id: 'One',
      question: 'How can my business benefit from partnering with Vasco?',
      ans: 'Partnering with Vasco can support your business growth by enhancing your visibility and improving customer engagement. The platform promotes subscription purchases, streamlines payments, and improves customer and marketing management, allowing you to focus on delivering amazing customer services. Vasco helps to expand your reach, track customer behavior, and maintain ongoing customer connection, contributing to business and revenue growth.',
    },
    {
      id: 'Two',
      question: 'What types of businesses can benefit from Vasco?',
      ans: 'Vasco is suitable for businesses in the wellness, fitness, and lifestyle sectors, such as personal trainers, dieticians, sports clubs, physiotherapists, and wellness centers. More sectors will be included soon. Whether you are a freelancer or an established business with staff and venues, Vasco provides a tailored solution to optimize your operations and improve connection to your customers.',
    },
    {
      id: 'Three',
      question: 'Can I add multiple locations of my business to the platform?',
      ans: 'Yes, Vasco allows you to easily add and manage multiple locations under one account, giving you full control and seamless oversight of all your business locations in a centralized platform. The Growth plan supports multi-location management, while the Growth Plus plan offers enhanced scalability for businesses with broader location needs.',
    },
    {
      id: 'Four',
      question: 'Do I need technical expertise to use Vasco’s platform?',
      ans: 'No, Vasco is designed to be intuitive and user-friendly, with no technical expertise required. The platform allows you to manage subscriptions, promote products and services, receive payments, and track customer interactions without needing IT support. All you need to use is your Vasco Partner Portal.',
    },
    {
      id: 'Five',
      question: 'Is there an initial set-up cost to get started with Vasco?',
      ans: 'No, Vasco operates on a zero-initial investment model, meaning there are no upfront costs. Its subscription-based structure allows businesses to begin benefiting immediately, making it a viable option for small businesses and freelancers who aim to streamline operations and grow their customer base.',
    },
    {
      id: 'Six',
      question: 'How can I create memberships for my customers?',
      ans: 'Creating memberships is straightforward with Vasco’s platform. You can define various memberships based on service items, duration (monthly or yearly), and pricing. The platform allows you to customize subscription details to suit your business needs and customer expectations.',
    },
    {
      id: 'Seven',
      question: 'Does Vasco provide any marketing tools to help promote my business?',
      ans: 'Yes, Vasco provides marketing tools to help you promote your business. You can set up push notifications to engage with your customers, keep them informed about your services, and encourage repeat business. These tools help you stay connected with your customers effortlessly.',
    },
    {
      id: 'Eight',
      question: 'Can I track the performance of my business on Vasco?',
      ans: 'Yes, Vasco offers comprehensive analytics tools to help you track customer behavior, subscription trends, and financial performance. You can access detailed reports on service usage, revenue, engagement metrics, and subscription sales. These insights empower you to make informed decisions, evaluate business performance, and optimize your offerings for growth.',
    },
    {
      id: 'Nine',
      question: 'What support resources are available for new users of Vasco?',
      ans: "Once you're onboarded in the Vasco Partner Portal, our team is here to support you every step of the way. If you need any assistance, simply reach out to us at help@vasco.life, and we’ll be happy to help.",
    },
    {
      id: 'Ten',
      question: 'What happens if I forget my password?',
      ans: "If you forget your password, click the 'Forgot Password?' link on the login page of the Partner Portal. Enter your email address and submit the request. You will receive a temporary password to login and reset your password.",
    },
    {
      id: 'Eleven',
      question: 'Can I cancel my subscription with Vasco?',
      ans: 'Yes, you can cancel your subscription at any time. Vasco’s subscription model is flexible, and you have the option to discontinue the service if it no longer meets your business needs. However, we encourage you to contact our support team for assistance (help@vasco.life) and to explore how we can address any concerns before making a final decision.',
    },
  ]

  useEffect(() => {
    if (packageRef.current && packageEnterpriceRef.current) {
      const height = Math.max(
        packageRef.current.clientHeight,
        packageEnterpriceRef.current.clientHeight
      )

      packageRef.current.style.height = `${height}px`
      packageEnterpriceRef.current.style.height = `${height}px`
    }

    if (packageRef2.current && packageEnterpriceRef2.current) {
      const height = Math.max(
        packageRef2.current.clientHeight,
        packageEnterpriceRef2.current.clientHeight
      )

      packageRef2.current.style.height = `${height}px`
      packageEnterpriceRef2.current.style.height = `${height}px`
    }
  }, [
    packageRef.current?.clientHeight,
    packageEnterpriceRef2.current?.clientHeight,
    packageEnterpriceRef2,
    packageRef2.current?.clientHeight,
  ])

  const changePackage = (packageID: string) => {
    localStorage.setItem('selectedPackage', packageID)
    setSelectedPackage(packages.find((item) => item?.packageID === packageID))
  }

  const getSelectedPackage = () => {
    const packageID = localStorage.getItem('selectedPackage')
    return packages.find((item) => item?.packageID === packageID)
  }

  useEffect(() => {
    const selectedPackage = getSelectedPackage()
    if (selectedPackage) {
      setSelectedPackage(selectedPackage)
    }
  }, [])

  const handleMakePayment = async (packacgeId: string) => {
    Swal.showLoading()
    if (!packacgeId || !merchantIDQuery) {
      Swal.close()
      return
    }

    const paymentValues = {
      subscriptionID: packacgeId,
      merchantID: merchantIDQuery,
      subscriptionType: paymentPeriod === 'monthly' ? '1' : '2',
    } as any

    const paymentResponse = await sendPayment({
      values: paymentValues,
    }).catch((error) => {
      Error(intl.formatMessage({id: 'ERROR'}))
      Swal.close()
    })

    if (!paymentResponse || !paymentResponse?.response?.data?.url) {
      Swal.close()
      return
    }
    setPaymentDialogUrl(paymentResponse?.response?.data?.url?.replace('///', '/'))
    Swal.close()
    setPaymentDialog(true)
  }

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data.type === 'error') {
        setPaymentDialog(false)
        setPaymentError(true)
        return
      }

      if (event.origin === paymentProviderUrl) {
        const resultUrl = event.data
        if (resultUrl?.includes('PaymentInfoCreditCard/1/Success/')) {
          console.log('Payment Successful')
          setPaymentDialog(false)
          setPaymentSuccess(true)

          const id = resultUrl.split('PaymentInfoCreditCard/1/Success/')[1]
          const referenceID = id.split('/')[1]
          // get last / id

          console.log('resultUrl', resultUrl)
          const transactionDetail = await getTransactionDetail({referenceID})
          setTransactionDetail(transactionDetail)

          // navigate('/sign-in')
        } else {
          // toast.error('Payment Failed')
          console.log('Payment Failed')
          setPaymentDialog(false)
          setPaymentError(true)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const handleCheckPayment = async () => {
    if (!iframeRef.current) {
      return
    }

    const iframe = iframeRef.current
    const iframeDomain = paymentProviderUrl
    if (iframeDomain) {
      const test = iframe.contentWindow?.postMessage('getURL', iframeDomain)
    }
  }

  // console.log('transactionDetail', transactionDetail)

  // transactionDetail
  //   {
  //     "responseResult": {
  //         "result": true,
  //         "exceptionDetail": null
  //     },
  //     "response": {
  //         "data": {
  //             "id": "cfa28d32-49a4-40c9-a818-20580d73921c",
  //             "referenceID": "068855107756",
  //             "referenceNumber": "2025000657",
  //             "invoiceNumber": "5318363",
  //             "paidAmount": 0,
  //             "paymentFrequency": 2,
  //             "paymentStatus": 0,
  //             "paymentMethod": 1,
  //             "paymentDate": "2025-03-19T09:42:41.303Z",
  //             "businessName": "Yucel AS",
  //             "subscriptionStatus": 0,
  //             "subscriptionStartDate": "2025-03-19T09:42:41.303Z",
  //             "subscriptionPlanName": "Basic - Trial",
  //             "subscriptionPlanDuration": 2,
  //             "subscriptionEndDate": "2025-04-02T09:42:41.303Z"
  //         }
  //     }
  // }

  if (paymentSuccess) {
    return (
      <PaymentSuccess
        isTransactionDetailLoading={isTransactionDetailLoading}
        transactionDetail={transactionDetail}
      />
    )
  }

  return (
    <Fragment>
      <ContactUs modal={modal} setModal={setModal} merchantData={merchantData} />

      <Modal
        centered
        show={paymentError}
        size='xl'
        dialogClassName='min-w-1200px'
        onHide={() => {
          setPaymentSuccess(false)
          setPaymentError(false)
        }}
      >
        <Modal.Body>
          {/* {paymentSuccess && (
            <>
              <div className='d-flex justify-content-center align-items-center w-100 p-7 h-100'>
                <div className='d-flex min-w-400px align-items-end w-100 justify-content-start gap-10 h-100'>
                  <div className='col-12'>
                    {isTransactionDetailLoading ? (
                      <div className='d-flex flex-column align-items-center justify-content-center h-100'>
                        <Spinner animation='border' />
                      </div>
                    ) : (
                      <>
                        <div className='row justify-content-center align-items-center mb-10'>
                          <div className='col-4'>
                            <img
                              src={Success2Img}
                              alt='Success'
                              style={{
                                width: '250px',
                                height: '250px',
                              }}
                            />
                          </div>
                          <div className='col-8'>
                            <h1 className='mb-5 fs-2 fs-lg-2x text-black'>Transaction Summary</h1>
                            <div
                              style={{
                                borderBottom: '1px solid #ccc',
                                marginBottom: '40px',
                                marginTop: '20px',
                              }}
                            >
                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Transaction Ref. No
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.referenceNumber}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Payment Status
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.paymentStatus === 0
                                        ? 'Success'
                                        : 'Fail'}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Invoice Number
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.invoiceNumber}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Payment Method
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.paymentMethod === 1
                                        ? 'Credit Card'
                                        : transactionDetail?.response?.data?.paymentMethod === 2
                                        ? 'Google Pay'
                                        : transactionDetail?.response?.data?.paymentMethod === 3
                                        ? 'Apple Pay'
                                        : ''}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Amount Paid
                                    </span>
                                    <span className='fw-semibold'>
                                      AED {transactionDetail?.response?.data?.paidAmount.toFixed(2)}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Date & Time of Payment
                                    </span>
                                    <span className='fw-semibold'>
                                      {new Date(
                                        transactionDetail?.response?.data?.paymentDate
                                      ).toLocaleDateString()}{' '}
                                      {new Date(
                                        transactionDetail?.response?.data?.paymentDate
                                      ).toLocaleTimeString()}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Payment Frequency
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.paymentFrequency === 1
                                        ? 'Recurring Monthly'
                                        : 'Recurring Yearly'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <h3 className='mb-3 mt-5 fs-2 fs-lg text-black'>Order Confirmation</h3>
                            <div style={{marginBottom: '40px'}}>
                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Business Name
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.businessName}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Subscription Plan
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.subscriptionPlanName}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Subscription Status
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.subscriptionStatus === 0
                                        ? 'Active'
                                        : 'Inactive'}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Plan Duration
                                    </span>
                                    <span className='fw-semibold'>
                                      {transactionDetail?.response?.data?.subscriptionPlanDuration}{' '}
                                      {transactionDetail?.response?.data?.paymentFrequency === 1
                                        ? 'Months'
                                        : 'Years'}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className='row mb-4'>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Subscription Start Date
                                    </span>
                                    <span className='fw-semibold'>
                                      {new Date(
                                        transactionDetail?.response?.data?.subscriptionStartDate
                                      ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <div className='d-flex align-items-center'>
                                    <span className='text-muted' style={{minWidth: '180px'}}>
                                      Subscription End Date
                                    </span>
                                    <span className='fw-semibold'>
                                      {new Date(
                                        transactionDetail?.response?.data?.subscriptionEndDate
                                      ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className='row mb-4 justify-content-center align-items-center'>
                      <div className='col-4'>
                        <div className='w-100'>
                          <h3 className='text-start text-primary fs-2x mt-5'>
                            {intl.formatMessage({
                              id: 'LANDING.CONGRATULATIONS',
                            })}
                          </h3>
                          <p
                            className='text-start fs-3 text-black w-100'
                            dangerouslySetInnerHTML={{
                              __html: intl.formatMessage({
                                id: 'LANDING.CONGRATULATIONS_DESC',
                              }),
                            }}
                          ></p>

                          <div className='d-flex justify-content-start w-50 mt-5'>
                            <a
                              type='button'
                              style={{
                                backgroundColor: '#000',
                                color: '#fff',
                              }}
                              className='btn px-10 d-flex align-items-center w-100 text-center justify-content-center'
                              href='/sign-in'
                            >
                              <i className='fa fa-arrow-right me-2 fs-3'></i>
                              {intl.formatMessage({
                                id: 'AUTH.GENERAL.SIGNIN_BUTTON',
                              })}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='col-8'>
                        <div
                          style={{backgroundColor: '#eeeeee', padding: '15px', borderRadius: '8px'}}
                        >
                          <h4 className='fs-6 mb-3'>Important Notes</h4>
                          <ul className='list-unstyled mb-0'>
                            <li className='mb-2 fs-7'>
                              • Temp Password... A confirmation email with your transaction details
                              has been sent to your registered email address. Please check your
                              inbox or spam folder.
                            </li>
                            <li className='mb-2 fs-7'>
                              • If your payment status is pending, it may take a few minutes to
                              process. You will receive a notification once it is completed.{' '}
                            </li>
                            <li className='mb-2 fs-7'>
                              • For any discrepancies or refund requests, please contact our support
                              team at help@vasco.life with your Transaction ID.
                            </li>
                            <li className='mb-2 fs-7'>
                              • Keep this confirmation for your records. If you need an invoice, you
                              can download it from your account dashboard.
                            </li>
                            <li className='mb-2 fs-7'>
                              • If this is a subscription payment, it may renew automatically. You
                              can manage or cancel it before the next billing cycle.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )} */}
          {paymentError && (
            <div className='text-center p-10'>
              <h1 className='text-danger fw-bold mb-10'>Payment Failed</h1>
              <p>
                Please try again. If the problem persists, please contact support at{' '}
                <a href='mailto:support@vasco.life'>support@vasco.life</a>
              </p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        centered
        size='xl'
        dialogClassName='min-h-500px p-0'
        id='paymentModal'
        show={paymentDialog}
        onHide={async () => {
          setPaymentDialog(false)
          await handleCheckPayment()
        }}
      >
        <Modal.Body className='rounded p-0 m-0 min-h-500px h-100 w-100'>
          <div className='modal-body h-100 p-0 m-0'>
            {/* <img
              src={'/media/vasco_logo.svg'}
              alt='Logo'
              style={{ width: 150 }}
              className='payment-logo'
            />
            <p>{hasChildren ? "İçerik var ✅" : "İçerik yok ❌"}</p> */}

            <iframe
              ref={iframeRef}
              src={paymentDialogUrl}
              style={{
                minHeight: '450px',
              }}
              width='100%'
              height='100%'
              title='Payment'
              allow='payment'
              onLoad={(e) => {
                if (paymentDialogUrl) {
                  iframeRef.current?.contentWindow?.postMessage('iframeLoaded', paymentDialogUrl)
                }

                // check children for iframe
                // const children = iframeRef.current?.contentWindow?.document.children
                // console.log('children', children)
              }}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={expandMore.status}
        onHide={() => setExpandMore({status: false, expandedPackageId: ''})}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {packages.find((item) => item.packageID === expandMore.expandedPackageId)?.packageName}{' '}
            Membership Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {packages.map((item, index) => {
            return (
              <>
                {expandMore.status && expandMore.expandedPackageId === item.packageID && (
                  <>
                    <div className='mb-7 text-center'>
                      <div className='text-center min-w-200px'>
                        <span className='mb-2'>AED</span>

                        <span className='fs-3x fw-bold'>{item.discountedPrice} </span>

                        <span className='fs-7 fw-semibold'>
                          /
                          <span>
                            {paymentPeriod === 'monthly'
                              ? intl.formatMessage({id: 'AUTH.SUBSCRIPTION.MON'})
                              : intl.formatMessage({id: 'AUTH.SUBSCRIPTION.YEAR'})}
                          </span>
                        </span>
                      </div>
                    </div>

                    <div className='w-100 mb-10'>
                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3 required`}>
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.MONTHLY_TRANSACTION',
                          })}
                        </span>
                        <span className='fw-bold fs-4'>{item.monthlyOrderLimit}</span>
                      </div>
                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3 `}>
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.MONTHLY_TRANSACTION_FEE_PER_LYT',
                          })}
                        </span>
                        <span className='fw-bold fs-4'>{item.monthlyTrxFeePerLylTrx}</span>
                      </div>
                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3 required`}>
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.PT_COUPON_RED_FEE',
                          })}
                          <span className='required'></span>
                        </span>
                        <span className='fw-bold fs-4'>{item.pointCouponRedemptionFee}</span>
                      </div>
                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.LYLTY_MEMBERS_SERVED',
                          })}
                        </span>
                        <span className='fw-bold fs-4'>{item.loyaltyMembersServed}</span>
                      </div>

                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                          {/* Email */}
                          {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.EmailPm'})}
                        </span>
                        <span className='fw-bold fs-4'>{item.email}</span>
                      </div>

                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                          {/* SMS */}
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.LYLTY_PORTAL_USER',
                          })}
                        </span>
                        <span className='fw-bold fs-4'>{item.portalUser}</span>
                      </div>

                      <div className='d-flex align-items-center mb-5'>
                        <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                          {/* Multi-Store */}
                          {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SUPPORT'})}
                        </span>
                        <span className='fw-bold fs-4'>{item.customerSupport}</span>
                      </div>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.FEATURED_DAYS',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.featuredDays}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {/* SMS */}
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.LYLTY_PORTAL_USER',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.portalUser}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {/* SMS */}
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.COST_PER_USER',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.costPerUser}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {/* Multi-Store */}
                        {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SUPPORT'})}
                      </span>
                      <span className='fw-bold fs-4'>{item.customerSupport}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3 `}>
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.PAYMENT_PROCESSING_COMMISSION',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.paymentProcessingCommission}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3 `}>
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.IN_APP_NOTIFICATIONS',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.inAppNotifications}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.INVENTORY_MANAGEMENT',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.inventoryManagement}</span>
                    </div>

                    <div className='d-flex align-items-center mb-5'>
                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                        {intl.formatMessage({
                          id: 'AUTH.SUBSCRIPTION.REPORTING',
                        })}
                      </span>
                      <span className='fw-bold fs-4'>{item.reporting}</span>
                    </div>
                  </>
                )}
              </>
            )
          })}
        </Modal.Body>
      </Modal>

      <div className='d-flex flex-column flex-root background-gradient' id='kt_app_root'>
        <div className='flex-column flex-column-fluid' id='kt_app_page'>
          <div className='flex-column-fluid'>
            <div className='d-flex flex-column gap-10'>
              <div
                className='container-fluid pt-8'
                id='kt_app_header_container'
                style={{
                  zIndex: 1000,
                }}
              >
                <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                  <a href='/sign-in'>
                    <img alt='Logo' src={Logo} style={{width: 150}} />
                  </a>
                </div>

                <div className='mt-10'>
                  <a
                    href='/become-a-merchant/merchant-form'
                    className='d-flex align-items-center gap-3'
                  >
                    <i className='bi bi-chevron-left fs-4 text-black'></i>
                    <span className='text-black fs-3 fw-bold'>Back</span>
                  </a>
                </div>
              </div>

              <div className='d-flex flex-column flex-root px-10 d-flex gap-10'>
                <div className='w-100'>
                  <div className='card mb-10' id=''>
                    {/*                 <Stepper activeStep={2} />
                     */}
                    <div className='card-title px-10 pt-10 pt-lg-20 d-flex justify-content-center align-items-center'>
                      <div className='d-flex flex-column align-items-center'>
                        <h1 className='text-start p-0 fw-bolder text-primary'>
                          {/* Ready to grow your business? */}
                          {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.READY_TO_GROW'})}
                        </h1>
                        <p className='p-0 fs-3'>
                          {/* Start turning every transaction into an opportunity for deeper customer
                      connections and increased sales. */}
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.START_TURNING_EVERY_TRANSACTION',
                          })}
                        </p>
                      </div>
                    </div>
                    <div className='mt-5 pl-0 ml-0 d-flex justify-content-center align-items-center'>
                      {/*        <h5 className='mb-1 text-black p-0 m-0 fw-normal fs-3'>
                            <b className='text-primary'>Try Vasco Life for 14 Days Free!</b> 🚀 No
                            charges will be made to your account for the first{' '}
                            <b className='text-primary'>14 days</b> – start exploring today!
                          </h5> */}

                      <img src={FreeTrialImg2} alt='Free Trial' className=' w-75' />
                    </div>
                    <div
                      className='card-body px-10 w-100 pb-10'
                      style={{
                        maxWidth: '100%',
                      }}
                    >
                      <div className='d-flex justify-content-center'>
                        <div
                          className='d-flex align-items-center justify-content-between gap-10 rounded p-2 w-25'
                          style={{
                            border: '1px solid #e0e0e0',
                          }}
                        >
                          <button
                            className={`btn w-100 py-5 ${
                              paymentPeriod === 'monthly' ? 'btn-dark text-white' : 'btn-text'
                            }`}
                            onClick={() => {
                              setPaymentPeriod('monthly')
                            }}
                            style={{
                              background:
                                paymentPeriod === 'monthly'
                                  ? 'linear-gradient(120deg,rgb(18, 18, 18) 0%,rgb(57, 57, 57) 100%)'
                                  : '',
                            }}
                          >
                            Monthly
                          </button>
                          <button
                            className={`btn w-100 py-5 ${
                              paymentPeriod === 'annual' ? 'btn-dark text-white' : 'btn-text'
                            }`}
                            onClick={() => {
                              setPaymentPeriod('annual')
                            }}
                            style={{
                              background:
                                paymentPeriod === 'annual'
                                  ? 'linear-gradient(120deg,rgb(18, 18, 18) 0%,rgb(57, 57, 57) 100%)'
                                  : '',
                            }}
                          >
                            Annual
                          </button>
                        </div>
                      </div>
                      {/*   <span className='text-start py-5 fs-2 text-primary'>
                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CHOOSE_YOUR_PLAN'})}
                  </span> */}
                      <div className='d-flex gap-5 mt-15' id=''>
                        {packages.map((item, index) => {
                          return (
                            <div
                              className='w-100'
                              ref={packageRef}
                              key={index}
                              onClick={() => {
                                setSelectedPackage(item)
                              }}
                              style={{
                                minHeight: '565px',
                              }}
                            >
                              <div className='d-flex align-items-center h-100'>
                                <div
                                  className={`w-100 h-100 d-flex flex-column justify-content-between rounded py-15 px-10 position-relative border border-5 hoverEffect ${
                                    selectedPackage?.packageID === item?.packageID
                                      ? 'border-primary'
                                      : 'border-gray-250'
                                  }`}
                                >
                                  <div className='mb-7 text-center'>
                                    <div className='d-flex justify-content-center w-100'>
                                      <p className='text-center w-75 text-muted'>
                                        {item.perfectFor}
                                      </p>
                                    </div>

                                    <h1
                                      className={`fw-bolder
                                  ${
                                    selectedPackage?.packageID === item?.packageID &&
                                    'text-primary fs-3x'
                                  }
                                  `}
                                    >
                                      {item.packageName}
                                    </h1>

                                    <div className='text-center min-w-200px'>
                                      <span className='fs-3x fw-bold'>
                                        {paymentPeriod === 'monthly'
                                          ? item.discountedPrice
                                          : item.annualPrice}
                                      </span>
                                      <span className='mb-2'>AED</span>

                                      <span className='fs-7 fw-semibold'>
                                        /
                                        <span>
                                          {paymentPeriod === 'monthly'
                                            ? intl.formatMessage({id: 'AUTH.SUBSCRIPTION.MON'})
                                            : intl.formatMessage({id: 'AUTH.SUBSCRIPTION.YEAR'})}
                                        </span>
                                      </span>
                                    </div>
                                  </div>

                                  <div className='w-100 mb-5'>
                                    <div className='d-flex align-items-center mb-3'>
                                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                        +{item.trxFee} Transaction Fee
                                      </span>
                                    </div>

                                    <div className='d-flex align-items-center mb-5'>
                                      <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                        +AED {Number(item.settlementFee).toFixed(2)} Settlement Fee
                                      </span>
                                    </div>
                                    {/*       <div className='d-flex align-items-center mb-5'>
                                      {item.addVenue && (
                                        <>
                                          +AED {Number(item.addVenue).toFixed(2)} / Additional
                                          Location
                                        </>
                                      )}
                                    </div> */}

                                    <div className=''>
                                      <span className='fs-4 fw-semibold d-flex flex-column'>
                                        <b>Key benefits include:</b>
                                        {item?.infoTitle}
                                      </span>
                                      <div className='mt-3'>
                                        {item?.infos.map((item, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className='d-flex gap-2 align-items-center'
                                            >
                                              <i className='fa-solid fa-check text-primary'></i>
                                              <span>{item}</span>
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </div>

                                    <div className='d-flex justify-content-start w-100 fw-bold fs-3 py-5'>
                                      <a
                                        href='#features'
                                        className='d-flex align-items-center gap-3'
                                      >
                                        <i className='fa-solid fa-angles-right text-primary'></i>
                                        <span>Details</span>
                                      </a>
                                    </div>
                                  </div>

                                  <button
                                    className={'btn btn-dark btn-sm py-5 text-white fs-3'}
                                    disabled={loadingBtn}
                                    onClick={async () => {
                                      setLoadingBtn(true)
                                      changePackage(item?.packageID)
                                      setLoadingBtn(false)
                                      await handleMakePayment(item?.packageID)
                                    }}
                                    style={{
                                      width: '100%',
                                    }}
                                  >
                                    <span>
                                      {/* Get Started */}
                                      {intl.formatMessage({id: 'GET_STARTED'})}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>

                      {/*   <div className='mt-10'>
                    <div
                      className='col-auto rounded'
                      style={{
                        backgroundColor: '#833ab4',
                        background: 'linear-gradient(to top left,#283048,#859398)',
                      }}
                    >
                      <div className='d-flex align-items-start py-3 text-white'>
                        <div className='w-100 d-flex flex-column flex-start rounded-3'>
                          <div className='text-center py-5 w-100  px-10'>
                            <h1 className='mb-5 fw-bolder text-white'>
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE'})}
                            </h1>

                            <div className='fw-semibold mb-5'>
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE_DESC'})}
                            </div>

                            <div className='text-center w-100'>
                              <a
                                href='#chat'
                                className='btn w-100 border border-2 border-gray-500'
                                style={{
                                  backgroundColor: '#000',
                                  background:
                                    'linear-gradient(to top left,#c4c5c7,#dcdddf,#ebebeb)',
                                  color: '#252525',
                                }}
                                onClick={() => {
                                  setModal(true)
                                }}
                              >
                                {intl.formatMessage({id: 'CONTACT_US'})}
                              </a>
                            </div>
                          </div>

                          <div
                            className='w-100 py-5 border-top border-bottom border-1 border-gray-500  px-10'
                 
                          >
                            <div className='d-flex align-items-start flex-column'>
                              <span className='fw-bold fs-1'>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CUSTOM'})}
                              </span>
                              <span className=''>
                                {intl.formatMessage({
                                  id: 'AUTH.SUBSCRIPTION.CUSTOM_ORDER_LIMITS',
                                })}
                              </span>
                            </div>
                          </div>

                          <div className='w-100 py-5 px-10'>
                            <div className='d-flex align-items-start flex-column'>
                              <span className='fw-bold'>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PREMIUM_PLUS'})}
                              </span>
                              <ul
                                style={{
                                  listStyleType: 'none',
                                }}
                                className='m-0 p-0 mt-2 d-flex flex-column gap-2'
                              >
                                <li className='d-flex gap-2 align-items-center'>
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMITS'})}
                                </li>
                                <li className='d-flex gap-2 align-items-center'>
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ALL_FEATURES'})}
                                </li>
                                <li className='d-flex gap-2 align-items-center'>
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.DEDICATED_SUPPORT',
                                  })}
                                </li>
                                <li className='d-flex gap-2 align-items-center'>
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SLACK_CONNECT'})}
                                </li>
                                <li className='d-flex gap-2 align-items-center'>
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.FULL_CUSTOMIZATION',
                                  })}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                      <div className='card shadow-none border-0 px-0 mx-0'>
                        <div className='card-header border-0 mb-6 px-0 mx-0'>
                          <h1 className='fs-2x text-primary my-6'>
                            {/* Create, Engage, and Thrive with Campaigns 🚀 */}
                            {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CREATE_ENGAGE_THRIVE'})}
                          </h1>
                          <p className='fs-5 fw-semibold w-100'>
                            {/* Enhance customer engagement and drive sales with our Campaign Engine. Our
                        easy-to-use platform lets you create and launch promotional campaigns
                        instantly— No technical support is needed! */}
                            {intl.formatMessage({
                              id: 'AUTH.SUBSCRIPTION.CREATE_ENGAGE_THRIVE_DESC',
                            })}
                          </p>
                        </div>
                        <div
                          id='features'
                          className='card-body py-5 py-lg-10 d-flex justify-content-between align-items-start px-0 mx-0'
                        >
                          <table className='table table-light table-striped'>
                            <thead>
                              <tr>
                                <th className='text-start'></th>
                                <th className='text-center fw-semibold fs-2'>Essential</th>
                                <th className='text-center fw-semibold fs-2'>Basic</th>
                                <th className='text-center fw-semibold fs-2'>Growth</th>
                                <th className='text-center fw-semibold fs-2'>Growth Plus</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* new */}
                              <tr className=''>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Transaction Fee
                                </td>
                                <td className='text-center min-w-200px'>10%</td>
                                <td className='text-center min-w-200px'>8%</td>
                                <td className='text-center min-w-200px'>6.5%</td>
                                <td className='text-center min-w-200px'>5%</td>
                              </tr>
                              <tr className=''>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Settlement Fee (AED)
                                </td>
                                <td className='text-center min-w-200px'>5.00</td>
                                <td className='text-center min-w-200px'>5.00</td>
                                <td className='text-center min-w-200px'>5.00</td>
                                <td className='text-center min-w-200px'>5.00</td>
                              </tr>
                              <tr className=''>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Additional Location
                                </td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>5</td>
                                <td className='text-center min-w-200px'>10</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Emails Included p. m.
                                </td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>500</td>
                                <td className='text-center min-w-200px'>2500</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1 ps-10'>
                                  Cost per Email (AED)
                                </td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>0.15</td>
                                <td className='text-center min-w-200px'>0.1</td>
                                <td className='text-center min-w-200px'>0.05</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Featured days included p.m.
                                </td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>2</td>
                                <td className='text-center min-w-200px'>5</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Partner Portal User
                                </td>
                                <td className='text-center min-w-200px'>1</td>
                                <td className='text-center min-w-200px'>2</td>
                                <td className='text-center min-w-200px'>3</td>
                                <td className='text-center min-w-200px'>5</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1 ps-10'>
                                  Cost per additional Portal User (AED) p.m.
                                </td>
                                <td className='text-center min-w-200px'>-</td>
                                <td className='text-center min-w-200px'>50.00</td>
                                <td className='text-center min-w-200px'>40.00</td>
                                <td className='text-center min-w-200px'>25.00</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Merchant Support
                                </td>
                                <td className='text-center min-w-200px'>Email</td>
                                <td className='text-center min-w-200px'>WhatsApp</td>
                                <td className='text-center min-w-200px'>
                                  Dedicated Account Manager
                                </td>
                                <td className='text-center min-w-200px'>
                                  Dedicated Account Manager
                                </td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  In-app Notifications p.m.
                                </td>
                                <td className='text-center min-w-200px'>No</td>
                                <td className='text-center min-w-200px'>10</td>
                                <td className='text-center min-w-200px'>25</td>
                                <td className='text-center min-w-200px'>50</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Inventory Management
                                </td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Reporting
                                </td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                                <td className='text-center min-w-200px'>Unlimited</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  List products and memberships
                                </td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Payments
                                </td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                              </tr>
                              <tr>
                                <td className='text-start d-flex align-items-center gap-1'>
                                  Transactions
                                </td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                                <td className='text-center min-w-200px'>Yes</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className='card border-0 shadow-none mt-10 px-0 mx-0'>
                        <div className='card-header border-0 px-0 mx-0'>
                          <h1 className='fs-2x text-primary my-6'>
                            {/* Frequently Asked Questions */}
                            {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ'})}
                          </h1>
                        </div>

                        <div className='card-body py-5 py-lg-10 px-0 mx-0'>
                          <div
                            className='accordion accordion-icon-collapse w-100 d-flex flex-column'
                            id='kt_accordion_faq'
                          >
                            {faqs.map((item, index) => {
                              return (
                                <div className='row' key={index}>
                                  <div className='mb-5 '>
                                    <div
                                      className='accordion-header collapsed py-3 d-flex'
                                      data-bs-toggle='collapse'
                                      data-bs-target={`#kt_accordion_faq_item_${index + 1}`}
                                    >
                                      <span className='accordion-icon'>
                                        <i className='ki-duotone ki-plus-square fs-3 accordion-icon-off'>
                                          <span className='path1'></span>
                                          <span className='path2'></span>
                                          <span className='path3'></span>
                                        </i>
                                        <i className='ki-duotone ki-minus-square fs-3 accordion-icon-on'>
                                          <span className='path1'></span>
                                          <span className='path2'></span>
                                        </i>
                                      </span>
                                      <h3 className='fs-4 fw-bold mb-0 ms-4'>
                                        {/* Do you price based on orders? */}
                                        {item.question}
                                      </h3>
                                    </div>

                                    <div
                                      // id='kt_accordion_faq_item_1'
                                      id={`kt_accordion_faq_item_${index + 1}`}
                                      className='collapse fs-6 ps-10'
                                      data-bs-parent='#kt_accordion_faq'
                                    >
                                      {item.ans}
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
